import { render, staticRenderFns } from "./MemberCreate.vue?vue&type=template&id=a3cbd2a8&scoped=true&"
import script from "./MemberCreate.vue?vue&type=script&lang=js&"
export * from "./MemberCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cbd2a8",
  null
  
)

export default component.exports